import React from 'react';
import { StyleSheet, View } from 'react-native';
import { useNavigation } from '@react-navigation/native';
import { BarreLaterale } from '../components/BarreLaterale';
import { useGabarit } from '../hooks/useGabarit';
import { interfaceRtl } from '../i18n/sens';
import type { TabKey } from '../types';

const ROUTE_PAR_ONGLET = { cvs: 'CVs', offers: 'Offers', news: 'News', profile: 'Profile' } as const;

/**
 * Pose la barre latérale autour d'un écran qui vit AU-DESSUS des onglets (le Coaching) : sans elle,
 * ouvrir le Coaching depuis l'ordinateur ferait disparaître toute la navigation, comme si l'on
 * quittait le site. Sur téléphone, rend l'enfant tel quel : aucun nœud en plus.
 */
export function CadreBarreLaterale({ children }: { children: React.ReactNode }) {
  const { large, etendu } = useGabarit();
  const navigation = useNavigation<{ navigate: (nom: string, params?: object) => void }>();
  if (!large) return <>{children}</>;

  const versOnglet = (cle: TabKey) => navigation.navigate('Main', { screen: ROUTE_PAR_ONGLET[cle] });
  return (
    <View style={[styles.cadre, interfaceRtl() && styles.cadreRtl]}>
      <BarreLaterale
        variante={etendu ? 'etendu' : 'moyen'}
        activeKey={null}
        onTabPress={versOnglet}
        onCoachingPress={() => undefined}
      />
      <View style={styles.contenu}>{children}</View>
    </View>
  );
}

const styles = StyleSheet.create({
  cadre: { flex: 1, flexDirection: 'row' },
  cadreRtl: { flexDirection: 'row-reverse' },
  contenu: { flex: 1, minWidth: 0 },
});
